import(/* webpackMode: "eager" */ "/vercel/path0/src/app/resource-discovery-center/page.tsx");
